export function contactAdd(formData) {
  return fetch(`${process.env.REACT_APP_API_HOST}/contact`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(formData)
  })
}
